import { connect } from 'react-redux';
// import Report from '../../components/digital_rating/Report';
import Dashboard from '../../components/dashboard/Dashboard';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
